module.exports = __webpack_public_path__ + "static/pic07-1125f68f5f26f4b766f8edf749ef615c.jpg";